







































































































import Vue from 'vue';
import { BRow, BCol } from 'bootstrap-vue';
import zenButton from '@reciprocity/button';
import { get } from 'lodash';
import { mapActions } from 'vuex';

import { StorageFolder, ListFolders } from './types';

export default Vue.extend({
  name: 'StorageIntegration',
  components: {
    BCol,
    BRow,
    zenButton,
  },
  props: {
    auditId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      errorMessage: null,
      isInitialized: false,
      isLoading: false,
      isEditing: false,
      isListingFoldersSupported: false,
      breadcrumbs: <StorageFolder[]>[],
      folders: <StorageFolder[]>[],
      currentFolder: <StorageFolder | null>null,
      selectedFolder: <StorageFolder | null>null,
    };
  },
  computed: {
    currentFolderValue(): string | null {
      return get(this.currentFolder, 'name', '');
    },
  },
  async created() {
    try {
      await this.init();
    } catch (err) {
      this.handleInitError(err);
    } finally {
      this.isInitialized = true;
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    ...mapActions('auditSetupWizard', ['loadIsListingFoldersSupported', 'loadFolder', 'loadListFolders']),
    async init() {
      if (this.auditId >= 0) {
        await this.handleInitWhenEditingAudit(this.auditId);
      } else {
        await this.handleInitWhenNewAudit();
      }
    },
    async handleInitWhenNewAudit() {
      this.isListingFoldersSupported = await this.loadIsListingFoldersSupported();
    },
    async handleInitWhenEditingAudit(auditId: number) {
      this.isListingFoldersSupported = await this.loadIsListingFoldersSupported();

      const folder: StorageFolder | null = await this.loadFolder(auditId);
      this.setFolder(folder);
    },
    /* eslint-disable complexity */
    handleInitError(err) {
      const message = get(err, 'response.data.message', null);
      const isKnownErrorType =
        message && (message.type === 'integration_not_found' || message.type === 'file_not_found');

      if (!message || !isKnownErrorType) {
        this.handleUnknownInitError(message);
      } else {
        this.handleKnownInitError(message);
      }
    },
    handleUnknownInitError(message: any) {
      this.showAlert({
        type: 'error',
        message: message || 'Evidence folder could not be loaded.',
      });
    },
    handleKnownInitError(message: any) {
      this.errorMessage = message.message;
      this.isListingFoldersSupported = message.is_listing_supported;
    },
    async change() {
      this.isEditing = true;
      this.selectedFolder = this.currentFolder;

      this.folders = [];
      this.breadcrumbs = [];

      await this.loadFolders(this.selectedFolder);

      this.selectedFolder = this.breadcrumbs[this.breadcrumbs.length - 1];
    },
    async selectFolder(folder: StorageFolder, event: Event) {
      event.preventDefault();

      this.selectedFolder = folder;

      await this.loadFolders(this.selectedFolder);
    },
    setFolder(folder: StorageFolder | null) {
      this.errorMessage = null;

      this.currentFolder = folder;

      this.$emit('setFolder', this.currentFolder);
    },
    reset() {
      this.setFolder(null);

      this.isEditing = false;
    },
    cancel() {
      this.isEditing = false;
    },
    confirm() {
      this.setFolder(this.selectedFolder);

      this.isEditing = false;
    },

    async loadFolders(selectedFolder: StorageFolder | null) {
      this.isLoading = true;

      this.folders = [];

      const storageFolder: StorageFolder = {
        integrationId: selectedFolder !== null ? selectedFolder.integrationId : null,
        location: selectedFolder !== null ? selectedFolder.location : null,
      };

      try {
        const result: ListFolders = await this.loadListFolders(storageFolder);

        this.folders = result.files;
        this.breadcrumbs = result.breadcrumbs;

        this.isLoading = false;
      } catch (err) {
        this.showAlert({
          type: 'error',
          message: 'Folder list could not be loaded.',
        });
      }
    },
  },
});
